/* UNMARKED F.C. — small interactions. No dependencies. */
(function () {
  // Product gallery: thumbnails swap the main image.
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-um-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-um-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-um-main]');
    if (!main) return;
    main.src = thumb.getAttribute('data-src');
    main.alt = thumb.getAttribute('data-alt') || '';
    main.removeAttribute('srcset');
    gallery.querySelectorAll('[data-um-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  // Pre-launch: picking a size tags the signup so we know demand per size.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-um-size]')) return;
    var form = input.closest('form');
    if (!form) return;
    var tags = form.querySelector('[data-um-tags]');
    if (tags) {
      var base = tags.getAttribute('data-base') || 'club';
      tags.value = base + ', notify-size-' + input.value;
    }
    var button = form.querySelector('[data-um-submit]');
    if (button) {
      var label = button.getAttribute('data-label') || button.textContent;
      button.textContent = label + ' · SIZE ' + input.value;
    }
  });

  // Mobile menu: close after choosing a link.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.um-menu__panel a');
    if (!link) return;
    var menu = link.closest('details');
    if (menu) menu.removeAttribute('open');
  });

  // Sticky mobile bar: hide it while the product section is on screen.
  // Also hidden while the hero is on screen, so it never covers the first view.
  var sticky = document.querySelector('.um-sticky');
  if (sticky && 'IntersectionObserver' in window) {
    var watched = [document.querySelector('.um-product'), document.querySelector('.um-hero')].filter(Boolean);
    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      sticky.classList.toggle('is-hidden', visible.size > 0);
    });
    watched.forEach(function (el) { observer.observe(el); });
  } else if (sticky) {
    sticky.classList.remove('is-hidden');
  }

  // Close the menu with Escape.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.um-menu[open]').forEach(function (menu) {
      menu.removeAttribute('open');
      var summary = menu.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();

// Size finder: pick the size that matches the chosen height.
(function () {
  document.querySelectorAll('[data-um-finder]').forEach(function (finder) {
    var select = finder.querySelector('[data-um-finder-select]');
    var result = finder.querySelector('[data-um-finder-result]');
    var form = finder.closest('form');
    if (!select || !form) return;
    select.addEventListener('change', function () {
      var size = select.value;
      if (!size) { result.textContent = ''; return; }
      var radio = form.querySelector('input[type="radio"][data-size="' + size + '"]');
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        result.textContent = 'Size ' + size + ' it is. Between two? Go up for room to grow.';
      } else {
        result.textContent = 'Size ' + size + ' fits best, but it’s sold out right now.';
      }
    });
  });
})();

// Share the club after signup.
(function () {
  document.querySelectorAll('[data-um-share]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    var text = box.getAttribute('data-text');
    var shareBtn = box.querySelector('[data-um-share-btn]');
    var copyBtn = box.querySelector('[data-um-copy-btn]');
    if (shareBtn) {
      if (!navigator.share) shareBtn.hidden = true;
      shareBtn.addEventListener('click', function () {
        navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
      });
    }
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var done = function () { copyBtn.textContent = 'Link copied'; };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done);
        else done();
      });
    }
  });
})();

// Printable gift card: live-type the names, then print.
(function () {
  var inputs = document.querySelectorAll('[data-um-card-input]');
  inputs.forEach(function (input) {
    var key = input.getAttribute('data-um-card-input');
    var target = document.querySelector('.um-print__preview [data-um-card-field="' + key + '"]');
    if (!target) return;
    var fallback = target.textContent;
    input.addEventListener('input', function () {
      target.textContent = input.value.trim() || fallback;
    });
  });
  document.querySelectorAll('[data-um-print]').forEach(function (btn) {
    btn.addEventListener('click', function () { window.print(); });
  });
})();
